// extracted by mini-css-extract-plugin
export var chip = "_4a-0";
export var filterDropdown = "_4a-5";
export var filterItem = "_4a-6";
export var icon = "_4a-1";
export var removeButton = "_4a-3";
export var removeIcon = "_4a-4";
export var separator = "_4a-2";